import { createHttpService } from '../ApiService';
import { TBranding } from './branding.interfaces';
import isAppWithMock from 'src/utils/isAppWithMock';

const brandingMockFallback: TBranding = {
  id: 'mock-branding-1',
  instituteId: 'mock-institute-1',
  primaryColor: '#3a36b8',
  secondaryColor: '#06B6D4',
  status: 'active',
};

export const useBrandingService = () => {
  const httpAPI = createHttpService();

  const getBranding = (instituteId?: string): Promise<TBranding> => {
    if (isAppWithMock()) {
      return Promise.resolve(brandingMockFallback);
    }
    const query = instituteId ? `?instituteId=${instituteId}` : '';
    return httpAPI.branding.get<TBranding>(query);
  };

  return { getBranding };
};
